import { createAction } from 'redux-act';
// Create Travel Application action
const createTravelApplicationRequest = createAction('CREATE_TRAVEL_APPLICATION_REQUEST', data => data);
const createTravelApplicationSuccess = createAction('CREATE_TRAVEL_APPLICATION_SUCCESS', data => data);
const createTravelApplicationError = createAction('CREATE_TRAVEL_APPLICATION_ERROR');

// Get Travel Request action
const getTravelRequestRequest = createAction('GET_ALL_TRAVEL_REQUEST_REQUEST', data => data);
const getTravelRequestSuccess = createAction('GET_ALL_TRAVEL_REQUEST_SUCCESS', data => data);
const getTravelRequestError = createAction('GET_ALL_TRAVEL_REQUEST_ERROR');

// Get Travel Approval list
const getTravelApprovalRequest = createAction('GET_TRAVEL_APPROVAL_REQUEST', data => data);
const getTravelApprovalSuccess = createAction('GET_TRAVEL_APPROVAL_SUCCESS', data => data);
const getTravelApprovalError = createAction('GET_TRAVEL_APPROVAL_ERROR');

// Update Travel action
const updateTravelApplicationRequest = createAction('UPDATE_TRAVEL_APPLICATION_REQUEST', data => data);
const updateTravelApplicationSuccess = createAction('UPDATE_TRAVEL_APPLICATION_SUCCESS', data => data);
const updateTravelApplicationError = createAction('UPDATE_TRAVEL_APPLICATION_ERROR');

// Delete Travel action
const deleteTravelRequest = createAction('DELETE_TRAVEL_REQUEST', data => data);
const deleteTravelSuccess = createAction('DELETE_TRAVEL_SUCCESS', data => data);
const deleteTravelError = createAction('DELETE_TRAVEL_ERROR');

// Add Travel Type action
const addTravelTypeRequest = createAction('ADD_TRAVEL_TYPE_REQUEST', data => data);
const addTravelTypeSuccess = createAction('ADD_TRAVEL_TYPE_SUCCESS', data => data);
const addTravelTypeError = createAction('ADD_TRAVEL_TYPE_ERROR');

// GET Travel Type action
const getTravelTypeRequest = createAction('GET_TRAVEL_TYPE_REQUEST', data => data);
const getTravelTypeSuccess = createAction('GET_TRAVEL_TYPE_SUCCESS', data => data);
const getTravelTypeError = createAction('GET_TRAVEL_TYPE_ERROR');

// Add Travel Type action
const deleteTravelTypeRequest = createAction('DELETE_TRAVEL_TYPE_REQUEST', data => data);
const deleteTravelTypeSuccess = createAction('DELETE_TRAVEL_TYPE_SUCCESS', data => data);
const deleteTravelTypeError = createAction('DELETE_TRAVEL_TYPE_ERROR');

// GET Update Travel Type action
const updateTravelTypeRequest = createAction('UPDATE_TRAVEL_TYPE_REQUEST', data => data);
const updateTravelTypeSuccess = createAction('UPDATE_TRAVEL_TYPE_SUCCESS', data => data);
const updateTravelTypeError = createAction('UPDATE_TRAVEL_TYPE_ERROR');

// GET All Travel Type action
const getAllTravelTypeRequest = createAction('GET_ALL_TRAVEL_TYPE_REQUEST', data => data);
const getAllTravelTypeSuccess = createAction('GET_ALL_TRAVEL_TYPE_SUCCESS', data => data);
const getAllTravelTypeError = createAction('GET_ALL_TRAVEL_TYPE_ERROR');


// GET All Travel Type action
const travelRequestApproveRejectRequest = createAction('TRAVEL_REQUEST_APPROVE_REJECT_REQUEST', data => data);
const travelRequestApproveRejectSuccess = createAction('TRAVEL_REQUEST_APPROVE_REJECT_SUCCESS', data => data);
const travelRequestApproveRejectError = createAction('TRAVEL_REQUEST_APPROVE_REJECT_ERROR');


// Create Travel And Claim Rule action
const createTravelAndClaimRuleRequest = createAction('CREATE_TRAVEL_AND_CLAIM_RULE_REQUEST', data => data);
const createTravelAndClaimRuleSuccess = createAction('CREATE_TRAVEL_AND_CLAIM_RULE_SUCCESS', data => data);
const createTravelAndClaimRuleError = createAction('CREATE_TRAVEL_AND_CLAIM_RULE_ERROR');

// Get Travel And Claim Rule action
const getTravelAndClaimRuleRequest = createAction('GET_TRAVEL_AND_CLAIM_RULE_REQUEST', data => data);
const getTravelAndClaimRuleSuccess = createAction('GET_TRAVEL_AND_CLAIM_RULE_SUCCESS', data => data);
const getTravelAndClaimRuleError = createAction('GET_TRAVEL_AND_CLAIM_RULE_ERROR');

// update Travel And Claim Rule action
const updateTravelAndClaimRuleRequest = createAction('UPDATE_TRAVEL_AND_CLAIM_RULE_REQUEST', data => data);
const updateTravelAndClaimRuleSuccess = createAction('UPDATE_TRAVEL_AND_CLAIM_RULE_SUCCESS', data => data);
const updateTravelAndClaimRuleError = createAction('UPDATE_TRAVEL_AND_CLAIM_RULE_ERROR');

// delete Travel And Claim Rule action
const deleteTravelAndClaimRuleRequest = createAction('DELETE_TRAVEL_AND_CLAIM_RULE_REQUEST', data => data);
const deleteTravelAndClaimRuleSuccess = createAction('DELETE_TRAVEL_AND_CLAIM_RULE_SUCCESS', data => data);
const deleteTravelAndClaimRuleError = createAction('DELETE_TRAVEL_AND_CLAIM_RULE_ERROR');

// get All Travel And Claim Rule action
const getAllTravelAndClaimRuleRequest = createAction('GET_ALL_TRAVEL_AND_CLAIM_RULE_REQUEST', data => data);
const getAllTravelAndClaimRuleSuccess = createAction('GET_ALL_TRAVEL_AND_CLAIM_RULE_SUCCESS', data => data);
const getAllTravelAndClaimRuleError = createAction('GET_ALL_TRAVEL_AND_CLAIM_RULE_ERROR');

// Assign Rule action
const assignRuleRequest = createAction('ASSIGN_RULE_REQUEST', data => data);
const assignRuleSuccess = createAction('ASSIGN_RULE_SUCCESS', data => data);
const assignRuleError = createAction('ASSIGN_RULE_ERROR');

// Get Assign Rule action
const getAssignRuleRequest = createAction('GET_ASSIGN_RULE_REQUEST', data => data);
const getAssignRuleSuccess = createAction('GET_ASSIGN_RULE_SUCCESS', data => data);
const getAssignRuleError = createAction('GET_ASSIGN_RULE_ERROR');

// Get Travel Type By Id action
const getTravelTypeByIdRequest = createAction('GET_TRAVEL_TYPE_BY_ID_REQUEST', data => data);
const getTravelTypeByIdSuccess = createAction('GET_TRAVEL_TYPE_BY_ID_SUCCESS', data => data);
const getTravelTypeByIdError = createAction('GET_TRAVEL_TYPE_BY_ID_ERROR');

// Create Claim Request action
const createClaimRequest = createAction('CREATE_CLAIM_REQUEST', data => data);
const createClaimSuccess = createAction('CREATE_CLAIM_SUCCESS', data => data);
const createClaimError = createAction('CREATE_CLAIM_ERROR');

// UPDATE Claim Request action
const updateClaimRequest = createAction('UPDATE_CLAIM_REQUEST', data => data);
const updateClaimSuccess = createAction('UPDATE_CLAIM_SUCCESS', data => data);
const updateClaimError = createAction('UPDATE_CLAIM_ERROR');

// Delete Claim Request action
const deleteClaimRequest = createAction('DELETE_CLAIM_REQUEST', data => data);
const deleteClaimSuccess = createAction('DELETE_CLAIM_SUCCESS', data => data);
const deleteClaimError = createAction('DELETE_CLAIM_ERROR');


// GET Claim Request action
const getClaimRequest = createAction('GET_CLAIM_REQUEST', data => data);
const getClaimSuccess = createAction('GET_CLAIM_SUCCESS', data => data);
const getClaimError = createAction('GET_CLAIM_ERROR');

// Delete Claim Request action
const getClaimApprovalRequest = createAction('GET_CLAIM_APPROVAL_REQUEST', data => data);
const getClaimApprovalSuccess = createAction('GET_CLAIM_APPROVAL_SUCCESS', data => data);
const getClaimApprovalError = createAction('GET_CLAIM_APPROVAL_ERROR');

// approve Reject Claim action
const approveRejectClaimRequest = createAction('APPROVE_REJECT_CLAIM_REQUEST', data => data);
const approveRejectClaimSuccess = createAction('APPROVE_REJECT_CLAIM_SUCCESS', data => data);
const approveRejectClaimError = createAction('APPROVE_REJECT_CLAIM_ERROR');

// get All Travel Approval Data action
const getAllTravelApprovalDataRequest = createAction('GET_ALL_TRAVEL_APPROVAL_DATA_REQUEST', data => data);
const getAllTravelApprovalDataSuccess = createAction('GET_ALL_TRAVEL_APPROVAL_DATA_SUCCESS', data => data);
const getAllTravelApprovalDataError = createAction('GET_ALL_TRAVEL_APPROVAL_DATA_ERROR');

const selectedTravelData = createAction('SELECTED_TRAVEL_DATA', data => data);
const selectedTravelClaimDetail = createAction('SELECTED_TRAVEL_CLAIM_DATA', data => data);


// clear existing Travel action
const handleClearTravelStore = createAction('HANDLE_CLEAR_TRAVEL_STORE', data => data);

export default {
    createTravelApplicationRequest,
    createTravelApplicationSuccess,
    createTravelApplicationError,

    getTravelRequestRequest,
    getTravelRequestSuccess,
    getTravelRequestError,

    getTravelApprovalRequest,
    getTravelApprovalSuccess,
    getTravelApprovalError,

    updateTravelApplicationRequest,
    updateTravelApplicationSuccess,
    updateTravelApplicationError,

    deleteTravelRequest,
    deleteTravelSuccess,
    deleteTravelError,

    addTravelTypeRequest,
    addTravelTypeSuccess,
    addTravelTypeError,

    getTravelTypeRequest,
    getTravelTypeSuccess,
    getTravelTypeError,

    updateTravelTypeRequest,
    updateTravelTypeSuccess,
    updateTravelTypeError,

    deleteTravelTypeRequest,
    deleteTravelTypeSuccess,
    deleteTravelTypeError,

    getAllTravelTypeRequest,
    getAllTravelTypeSuccess,
    getAllTravelTypeError,

    travelRequestApproveRejectError,
    travelRequestApproveRejectSuccess,
    travelRequestApproveRejectRequest,

    createTravelAndClaimRuleError,
    createTravelAndClaimRuleSuccess,
    createTravelAndClaimRuleRequest,

    getTravelAndClaimRuleError,
    getTravelAndClaimRuleSuccess,
    getTravelAndClaimRuleRequest,

    updateTravelAndClaimRuleError,
    updateTravelAndClaimRuleSuccess,
    updateTravelAndClaimRuleRequest,

    deleteTravelAndClaimRuleError,
    deleteTravelAndClaimRuleSuccess,
    deleteTravelAndClaimRuleRequest,

    getAllTravelAndClaimRuleError,
    getAllTravelAndClaimRuleSuccess,
    getAllTravelAndClaimRuleRequest,

    assignRuleError,
    assignRuleSuccess,
    assignRuleRequest,
    
    getAssignRuleError,
    getAssignRuleSuccess,
    getAssignRuleRequest,

    getTravelTypeByIdError,
    getTravelTypeByIdSuccess,
    getTravelTypeByIdRequest,

    createClaimError,
    createClaimSuccess,
    createClaimRequest,

    updateClaimError,
    updateClaimSuccess,
    updateClaimRequest,

    deleteClaimError,
    deleteClaimSuccess,
    deleteClaimRequest,

    getClaimError,
    getClaimSuccess,
    getClaimRequest,

    getClaimApprovalError,
    getClaimApprovalSuccess,
    getClaimApprovalRequest,

    approveRejectClaimError,
    approveRejectClaimSuccess,
    approveRejectClaimRequest,

    getAllTravelApprovalDataError,
    getAllTravelApprovalDataSuccess,
    getAllTravelApprovalDataRequest,

    selectedTravelData,
    selectedTravelClaimDetail,
    handleClearTravelStore,

}